import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import {
  IfreeConsultationModel
} from './types';

export const freeConsultation = (
  data: IfreeConsultationModel,
): TAxiosResponse<any> => api.post('freeConsultation', data);

export const gtagApi = {
  freeConsultation,
};
